const DashBoardGerencial = () => import('../../spa/dashboard-gerencial/DashBoardGerencial');

export default {
  path: 'dashboard-gerencial',
  name: 'dashboard-gerencial',
  component: DashBoardGerencial,
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/config/router/dashboard-gerencial.js